/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'

/** Common Components */
import CardSection from '../../../../../../../components/ui/card/CardSection'
import MolGrid, { Column } from "@moltech/molui/molgrid";
import CustomCenterModel from '../../../../../../../components/ui/customCenterModel/CustomCenterModel';
import { AppIcons } from '../../../../../../../data/appIcons';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import FormCreator from '../../../../../../../components/finalForms/FormCreator';
import SwalAlert from '../../../../../../../services/swalService/SwalService';
import ToastService from '../../../../../../../services/toastService/ToastService';

/** Utilities */
import { findFieldsById } from '../../../../../../../utils/formFieldUtils/ManageFields';

/** RTK Query */
import { useAddContractDeferralPeriodMutation, useDeleteContractDeferralPeriodMutation, useLazyGetAllContractDeferralPeriodsQuery, useUpdateContractDeferralPeriodMutation } from '../../../../../../../app/services/contractAPI';

/** Configuration files */
import { deferralPeriodsFormConfig } from './DeferralPeriods.formfield.config';

const DeferralPeriods = (props) => {

    const deferralPeriodsRef = useRef();
    const { confirm, warning } = SwalAlert();
    const [deferralPeriodsForm, setDeferralPeriodsForm] = useState(deferralPeriodsFormConfig);
    const [deferralPeriodsData, setdeferralPeriodsData] = useState([]);
    const [rowData, setRowData] = useState(null);
    const [isModelOpen, setIsModelOpen] = useState(false);

    const [getAllContractDeferralPeriods, {
        isFetching: isAllContractDeferralPeriodsFetching,
        isSuccess: isAllContractDeferralPeriodsFetched,
        data: AllContractdeferralPeriodsData,
    }] = useLazyGetAllContractDeferralPeriodsQuery();

    const [addContractDeferralPeriod, {
        isSuccess: isContractDeferralPeriodAdded,
        data: ContractDeferralPeriodData,
    },] = useAddContractDeferralPeriodMutation();

    const [deleteContractDeferralPeriod, {
        isSuccess: isContractDeferralPeriodDeleted,
        data: deleteContractDeferralPeriodData
    }] = useDeleteContractDeferralPeriodMutation();


    const [updateContractDeferralPeriod, {
        isSuccess: isContractDeferralPeriodUpdated,
        data: updateContractDeferralPeriodData,
    },] = useUpdateContractDeferralPeriodMutation();


    useEffect(() => {
        getAllContractDeferralPeriods(props.contractId);
    }, [props.contractId]);

    useEffect(() => {
        if (!isAllContractDeferralPeriodsFetching && isAllContractDeferralPeriodsFetched && AllContractdeferralPeriodsData) {
            setdeferralPeriodsData(AllContractdeferralPeriodsData);
        }
    }, [isAllContractDeferralPeriodsFetching, isAllContractDeferralPeriodsFetched, AllContractdeferralPeriodsData])

    useEffect(() => {
        if (isContractDeferralPeriodAdded && ContractDeferralPeriodData) {
            if (ContractDeferralPeriodData?.errorMessage) {
                if (ContractDeferralPeriodData?.errorMessage.includes("exists")) {
                    ToastService.error(ContractDeferralPeriodData?.errorMessage);
                }
                else {
                    ToastService.success(ContractDeferralPeriodData?.errorMessage);
                    handleCloseModel();
                }
            }
        }
    }, [isContractDeferralPeriodAdded, ContractDeferralPeriodData]);

    useEffect(() => {
        if (isContractDeferralPeriodDeleted && deleteContractDeferralPeriodData) {
            if (deleteContractDeferralPeriodData) {
                ToastService.success(deleteContractDeferralPeriodData?.errorMessage);
                getAllContractDeferralPeriods(props.contractId);
            }
            else {
                ToastService.error("Something went wrong");
            }
        }
    }, [isContractDeferralPeriodDeleted, deleteContractDeferralPeriodData]);


    useEffect(() => {
        if (isContractDeferralPeriodUpdated && updateContractDeferralPeriodData) {
            if (updateContractDeferralPeriodData) {
                ToastService.success(updateContractDeferralPeriodData?.errorMessage);
                handleCloseModel();
            }
        }
    }, [isContractDeferralPeriodUpdated, updateContractDeferralPeriodData]);

    const handaleSave = () => {
        const formData = deferralPeriodsRef?.current?.getFormData();
        if (formData) {
            const payload = {
                plContractKey: props.contractId,
                pdtStartDate: rowData
                    ? new Date(new Date(formData?.deferralStartDate).setDate(new Date(formData?.deferralStartDate).getDate() + 1))
                    : formData?.deferralStartDate,
                pdtEndDate: formData?.deferralEndDate,
                psReason: formData?.deferralReason,
            };
            rowData ? updateContractDeferralPeriod(payload) : addContractDeferralPeriod(payload);
        }
    }

    const handleEditRowData = (row) => {
        setRowData(row);
        const updatedForm = { ...deferralPeriodsForm };
        const pdtStartDate = findFieldsById(updatedForm, "deferralStartDate");
        pdtStartDate.fieldSetting.isDisable = true;
        updatedForm.initialState = {
            deferralStartDate: new Date(row?.dtContractDeferralStartDate),
            deferralEndDate: new Date(row?.dtContractDeferralEndDate),
            deferralReason: row?.sContractDeferralReason,
        };
        setDeferralPeriodsForm(updatedForm);
        setIsModelOpen(true);
    };

    const handleCloseModel = () => {
        setIsModelOpen(false);
        setRowData(null);
        resetForm();
        getAllContractDeferralPeriods(props.contractId);
    }


    const resetForm = () => {
        let formData = { ...deferralPeriodsForm };
        formData.initialState = {};
        const pdtStartDate = findFieldsById(formData, "deferralStartDate");
        pdtStartDate.fieldSetting.isDisable = false;
        setDeferralPeriodsForm(formData);
    };

    const handleColumnChange = async (dataField, updatedFormData) => {
        const today = new Date();

        if (dataField === "deferralStartDate") {
            const oneMonthAgo = new Date(today);
            oneMonthAgo.setMonth(today.getMonth() - 1);

            const twoMonthsAhead = new Date(today);
            twoMonthsAhead.setMonth(today.getMonth() + 2);

            const sixMonthsAhead = new Date(today);
            sixMonthsAhead.setMonth(today.getMonth() + 6);

            const enteredDate = new Date(updatedFormData[dataField]);

            if (enteredDate < oneMonthAgo) {
                const confirmPast = await confirm(
                    "The Start Date entered is more than a month in the past.",
                    "Are you sure this is correct?",
                    "Yes",
                    "No"
                );

                if (!confirmPast) {
                    let form = { ...deferralPeriodsForm };
                    form.initialState = {
                        ...updatedFormData,
                        deferralStartDate: null,
                    };
                    setDeferralPeriodsForm(form);
                    return;
                }
            }
            else if (enteredDate > sixMonthsAhead) {
                await warning(
                    "Invalid Start Date. The Start Date cannot be more than 6 months in the future."
                );
                let form = { ...deferralPeriodsForm };
                form.initialState = {
                    ...updatedFormData,
                    deferralStartDate: null,
                };
                setDeferralPeriodsForm(form);
                return;
            }
            else if (enteredDate > twoMonthsAhead) {
                const confirmFuture = await confirm(
                    "The Start Date entered is more than two months in the future.",
                    "Are you sure this is correct?",
                    "Yes",
                    "No"
                );

                if (!confirmFuture) {
                    let form = { ...deferralPeriodsForm };
                    form.initialState = {
                        ...updatedFormData,
                        deferralStartDate: null,
                    };
                    setDeferralPeriodsForm(form);
                    return;
                }
            }
        }
        else if (dataField === "deferralEndDate") {
            const oneYearAhead = new Date(today);
            oneYearAhead.setFullYear(today.getFullYear() + 1);

            const enteredEndDate = new Date(updatedFormData[dataField]);
            const enteredStartDate = new Date(updatedFormData["deferralStartDate"]);


            if (enteredEndDate < today) {
                const confirmPastEnd = await confirm(
                    "The End Date entered is in the past.",
                    "Are you sure this is correct?",
                    "Yes",
                    "No"
                );

                if (!confirmPastEnd) {
                    let form = { ...deferralPeriodsForm };
                    form.initialState = {
                        ...updatedFormData,
                        deferralEndDate: null,
                    };
                    setDeferralPeriodsForm(form);
                    return;
                }
            }

            else if (enteredEndDate > oneYearAhead) {
                await warning(
                    "Invalid End Date. The End Date cannot be more than one year in the future."
                );
                let form = { ...deferralPeriodsForm };
                form.initialState = {
                    ...updatedFormData,
                    deferralEndDate: null,
                };
                setDeferralPeriodsForm(form);
                return;
            }

            else if (enteredStartDate && enteredEndDate < enteredStartDate) {
                await warning(
                    "Invalid End Date. The End Date cannot be prior to the Start Date."
                );
                let form = { ...deferralPeriodsForm };
                form.initialState = {
                    ...updatedFormData,
                    deferralEndDate: null,
                };
                setDeferralPeriodsForm(form);
                return;
            }
        }
    };

    const handleDeleteRowData = (rowData) => {
        confirm(
            "Are you sure you want to delete this Deferral Period?",
            "",
            "Delete",
            "Cancel"
        ).then((confirmed) => {
            if (confirmed) {
                const payload = {
                    plContractKey: props.contractId,
                    pdtStartDate: rowData?.dtContractDeferralStartDate || null,
                };
                deleteContractDeferralPeriod(payload);
            }
        });
    }

    const getCtxMenuItems = (row) => {
        if (!row) return [];
        return [
            {
                label: 'Edit Deferral Periods',
                command: () => { handleEditRowData(row) }
            },
            {
                label: 'Delete Deferral Periods',
                command: () => { handleDeleteRowData(row) }
            }
        ];
    }

    return (
        <div>
            <CardSection
                cardTitle={"Deferral Periods"}
                rightButton={true}
                isButtonVisible={true}
                buttonClassName="btn blue-btn w-full"
                buttonText="Add"
                titleButtonClick={() => setIsModelOpen(true)}
            >
                <MolGrid
                    value={deferralPeriodsData}
                    grouping
                    expandableRowGroups={true}
                    paginator={false}
                    scrollable
                    scrollHeight="flex"
                    filterDisplay="row"
                    sortMode="single"
                    showGridlines
                    resizableColumns
                    ctxMenuItems={getCtxMenuItems}
                >
                    <Column field="dtContractDeferralStartDate" header="Start Date" colType="datetime"  format="mm/dd/yyyy" bodyStyle={{ textAlign: "center" }} grouping sortable />
                    <Column field="dtContractDeferralEndDate" header="End Date" colType="datetime" format="mm/dd/yyyy" bodyStyle={{ textAlign: "center" }} grouping sortable />
                    <Column field="sContractDeferralReason" header="Reason" bodyStyle={{ textAlign: "center" }} grouping sortable />
                </MolGrid>
            </CardSection>
            <div>
                <CustomCenterModel
                    isOpen={isModelOpen}
                    useCustomBg={true}
                    modalTitle={`${rowData ? "Edit" : "Add"} Deferral Periods`}
                    contentClass="content-35"
                    onClose={handleCloseModel}
                    modalTitleIcon={AppIcons.AddIcon}
                    className="add-contract-department"
                >
                    <FormCreator
                        ref={deferralPeriodsRef}
                        config={deferralPeriodsForm}
                        onColumnChange={handleColumnChange}

                    />
                    <div className="d-flex justify-content-center button-submit mt-2">
                        <Buttons
                            buttonText="Save"
                            buttonTypeClassName="btn blue-btn w-full"
                            onClick={handaleSave}
                        // isDisable={!isEditContract}
                        />
                        <Buttons
                            buttonText="Cancel"
                            buttonTypeClassName="btn secondary-btn ml-4"
                            onClick={handleCloseModel}
                        />
                    </div>
                </CustomCenterModel>
            </div>
        </div>
    )
}
export default DeferralPeriods
